import React from "react"
import Popover from "@material-ui/core/Popover"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme => ({
  menu: {
    padding: 0,
  },
  menuItem: {
    cursor: "pointer",
    background: "#fff",
    width: "200px",
    height: "30px",
    padding: 0,
    paddingLeft: "8px",
    "&:hover": {
      background: "#FAFAFC",
    },
  },
  menuItemIcon: {
    minWidth: "28px",
  },
  menuItemText: {
    "& span": {
      fontSize: "0.75rem !important",
    },
  },
}))

/**
 * @param object {{
 * children
 * menuItems: {
 * text: string
 * icon: object
 * onClick: function
 * }[]
 * }}
 */
export default function DropdownMenu({ children, menuItems }) {
  const classes = useStyles({})
  const [isOpen, setIsOpen] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const wrapperRef = React.useRef(null)

  const handlePopoverOpen = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
    setIsOpen(true)
  }

  const handlePopoverClosed = event => {
    setAnchorEl(null)
    setIsOpen(false)
  }

  function handleClickOutside() {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      handlePopoverClosed()
    }
  }

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [wrapperRef])

  function mapMenuItems(items) {
    return items.map((itm, index) => {
      function handleOnClick(event) {
        event.stopPropagation()
        handlePopoverClosed()
        if (itm.onClick != null) {
          itm.onClick(event)
        }
      }

      return (
        <span key={index}>
          <ListItem
            key={`${itm.text}-key-${index}`}
            className={classes.menuItem}
            onClick={handleOnClick}
          >
            <ListItemIcon className={classes.menuItemIcon}>
              {itm.icon}
            </ListItemIcon>
            <ListItemText className={classes.menuItemText}>
              {itm.text}
            </ListItemText>
          </ListItem>
        </span>
      )
    })
  }

  return (
    <>
      {React.cloneElement(children, {
        onClick: handlePopoverOpen,
      })}
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List className={classes.menu} ref={wrapperRef}>
          {mapMenuItems(menuItems)}
        </List>
      </Popover>
    </>
  )
}
